import { useState } from 'react';

import Typography from 'components/CncUI/Typography';
import TextField from 'components/CncUI/TextField';

import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(({ palette }) => ({
  center: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 24,
  },
  qrContainer: {
    width: 164,
    height: 164,
    border: `1px solid ${palette.cncUI.primary.gray['+6']}`,
  },
  title: {
    fontWeight: 400,
    marginTop: 52,
  },
  link: {
    color: palette.cncUI.primary.gray['+0'],
    fontSize: 18,
    fontWeight: 400,
    cursor: 'pointer',
  },
  code: {
    width: 210,
    marginTop: 20,
  },
}));

const QRCode = props => {
  const classes = useStyles();
  const { code, setCode, factor, modifyState } = props;
  const [show, showSecret] = useState(false);
  const { activation } = JSON.parse(factor.embedded);

  return (
    <>
      <Grid item xs={12} className={classes.center}>
        <div className={classes.qrContainer}>
          <img src={activation._links.qrcode.href} alt="Okta Verify QR Code" />
        </div>
      </Grid>
      <Grid item xs={12}>
        <Link
          className={classes.link}
          id="QRCodeNoBarcodeLink"
          onClick={() => {
            modifyState({
              section: 'secretKey',
              title: 'Secret key',
              subTitle:
                'Select “No Barcode” in the Okta Verify application to show the secret key screen. Type this secret key into that field.',
            });
            showSecret(true);
          }}
        >
          Can't scan?
        </Link>
      </Grid>
      {show && (
        <>
          <Grid item xs={12}>
            <p>Use this secret key on your mobile application</p>
          </Grid>
          <Grid item xs={12}>
            <span>{activation.sharedSecret}</span>
          </Grid>
        </>
      )}
      <Grid item xs={12}>
        <Typography variant="h4" className={classes.title}>
          Enter Code
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2">
          A six digit code will be displayed in your Okta Verify application
          after scanning the QR code. Enter the code in the text field below.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <TextField
          light
          className={classes.code}
          placeholder="Enter code here"
          value={code}
          onChange={e => setCode(e.target.value.replace(/\D/g, ''))}
          id="QRCodeCodeInput"
          autoComplete="one-time-code"
          autoFocus
          inputProps={{
            pattern: '[0-9]*',
            inputMode: 'numeric',
          }}
        />
      </Grid>
    </>
  );
};

export default QRCode;
